import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seller_filter = _resolveComponent("seller-filter");
  const _component_marketplace_filter = _resolveComponent("marketplace-filter");
  const _component_custom_filter = _resolveComponent("custom-filter");
  const _component_filters_frame = _resolveComponent("filters-frame");
  return _openBlock(), _createBlock(_component_filters_frame, {
    class: "dsp-reporting-filters"
  }, {
    default: _withCtx(() => [_createVNode(_component_seller_filter, {
      sellers: _ctx.sellers_filter,
      onApply: $options.applySellers
    }, null, 8, ["sellers", "onApply"]), _createVNode(_component_marketplace_filter, {
      marketplaces: _ctx.marketplaces_filter,
      onApply: $options.applyMarketplaces
    }, null, 8, ["marketplaces", "onApply"]), _createVNode(_component_custom_filter, {
      items: _ctx.campaigns,
      onApply: $options.applyCampaigns,
      item_key: "order_id",
      item_name: "order_name",
      type: "dsporders",
      title: "All Orders",
      bodyTitle: "Orders",
      filter_id: "dsporders",
      search_placeholder: "Search orders",
      icon: "LayersIcon"
    }, null, 8, ["items", "onApply"]), _createVNode(_component_custom_filter, {
      items: _ctx.line_items,
      onApply: $options.applyLineItems,
      item_key: "line_item_id",
      item_name: "line_item_name",
      type: "dsplineitem",
      title: "All Line Items",
      bodyTitle: "Line Items",
      filter_id: "dsplineitems",
      search_placeholder: "Search line items",
      icon: "TrendingUpIcon"
    }, null, 8, ["items", "onApply"])]),
    _: 1
  });
}